module.exports = __webpack_public_path__ + "static/media/stcc.30837369.jpg";